module.exports = __webpack_public_path__ + "img/5.df57799b.jpg";